module.exports = __webpack_public_path__ + "static/media/banner_loyalty.68fc50d8.png";